import config from './config';

const filterTypes = [
  {
    key: 'organization_key',
    label: 'Organization',
    subFilters: [
      { key: 'organization_name_contains', label: config.SUBFILTER_CONTAINS, subFilterType: config.SUBFILTER_CONTAINS, type: 'text', placeholder: '' },
      { key: 'organization_name', label: config.SUBFILTER_EQUALS, subFilterType: config.SUBFILTER_EQUALS, type: 'text', placeholder: '' }
    ]
  },
  {
    key: 'created',
    label: 'Created',
    subFilters: [
      { key: config.CREATED_BEFORE, label: 'before', subFilterType: config.SUBFILTER_DATE, type: 'date', placeholder: '' },
      { key: config.CREATED_AFTER, label: 'after', subFilterType: config.SUBFILTER_DATE, type: 'date', placeholder: '' },
      { key: config.CREATED_IN, label: 'in the last (days)', subFilterType: config.SUBFILTER_DATE_RANGE, type: 'number', placeholder: 'e.g. 7 days' },
    ]
  },
  {
    key: 'station_key',
    label: 'Station ID',
    subFilters: [
      { key: 'station', label: config.SUBFILTER_EQUALS, subFilterType: config.SUBFILTER_EQUALS, type: 'text', placeholder: '' },
      { key: 'station_contains', label: config.SUBFILTER_CONTAINS, subFilterType: config.SUBFILTER_CONTAINS, type: 'text', placeholder: '' }
    ]
  },
  {
    key: 'device_class_key',
    label: 'Device Class',
    subFilters: [
      { key: 'device_class', label: config.SUBFILTER_EQUALS, subFilterType: config.SUBFILTER_EQUALS, type: 'text', placeholder: '' },
      { key: 'device_class_contains', label: config.SUBFILTER_CONTAINS, subFilterType: config.SUBFILTER_CONTAINS, type: 'text', placeholder: '' }
    ]
  },
  {
    key: 'serial_key',
    label: 'Serial',
    subFilters: [
      { key: 'serial', label: config.SUBFILTER_EQUALS, subFilterType: config.SUBFILTER_EQUALS, type: 'text', placeholder: '' },
      { key: 'serial_contains', label: config.SUBFILTER_CONTAINS, subFilterType: config.SUBFILTER_CONTAINS, type: 'text', placeholder: '' }
    ]
  },
  {
    key: 'state_key',
    label: 'State',
    subFilters: [
      { key: 'state', label: config.SUBFILTER_EQUALS, subFilterType: config.SUBFILTER_EQUALS, type: 'text', placeholder: '' }
    ]
  }
];

export default filterTypes;
